'use client'

import { useHomeRedirect } from 'links/home/client/useHomeRedirect'
import React, { useEffect } from 'react'
import { useSession } from 'session/src/hooks/useSession'

export function RedirectOnGuest({
	children,
}: {
	readonly children: React.ReactNode
}) {
	const { isReady, logged } = useSession()
	const { homeReplace } = useHomeRedirect()

	useEffect(() => {
		if (isReady && !logged) {
			homeReplace()
		}
	}, [isReady, logged])

	return logged ? children : null
}
